import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './lib/auth';
import { HomePage } from './pages/PublicPortal/HomePage';
import { BankKontenPage } from './pages/PublicPortal/BankKontenPage';
import { LaporIsuPage } from './pages/PublicPortal/LaporIsuPage';
import { SeriesTematikPage } from './pages/PublicPortal/SeriesTematikPage';
import { SeriesDetailPage } from './pages/PublicPortal/SeriesDetailPage';
import { EventAksiPage } from './pages/PublicPortal/EventAksiPage';
import { EventDetailPage } from './pages/PublicPortal/EventDetailPage';
import { EventCheckinPage } from './pages/PublicPortal/EventCheckinPage';
import { KomunitasPage } from './pages/PublicPortal/KomunitasPage';
import { KomunitasDetailPage } from './pages/PublicPortal/KomunitasDetailPage';
import { TrackLaporanPage } from './pages/PublicPortal/TrackLaporanPage';
import { PartisipasiSurveiPage } from './pages/PublicPortal/PartisipasiSurveiPage';
import { PortalSelector } from './pages/PortalSelector';
// Officer App Imports
import { OfficerDashboard } from './pages/OfficerApp/OfficerDashboard';
import { ChecklistPage } from './pages/OfficerApp/ChecklistPage';
import { LaporanPage } from './pages/OfficerApp/LaporanPage';
import { IsuLapanganPage } from './pages/OfficerApp/IsuLapanganPage';
import { MateriPage } from './pages/OfficerApp/MateriPage';
import { ProofOfPerformancePage } from './pages/OfficerApp/ProofOfPerformancePage';
import { EventOfficerPage } from './pages/OfficerApp/EventOfficerPage';
import { DistribusiDariPusatPage } from './pages/OfficerApp/DistribusiDariPusatPage';
import { DetailAssignmentPage } from './pages/OfficerApp/DetailAssignmentPage';
import { SubmitBuktiPostingPage } from './pages/OfficerApp/SubmitBuktiPostingPage';
// Command Center Imports
import { DashboardNasional } from './pages/CommandCenter/DashboardNasional';
import { SkoringDaerahPage } from './pages/CommandCenter/SkoringDaerahPage';
import { IsuKrisisPage } from './pages/CommandCenter/IsuKrisisPage';
import { LoginPage } from './pages/Auth/LoginPage';
import { UnauthorizedPage } from './pages/Auth/UnauthorizedPage';
import { ManajemenKontenPage } from './pages/CommandCenter/ManajemenKontenPage';
import { EventNasionalPage } from './pages/CommandCenter/EventNasionalPage';
import { KomunitasMouPage } from './pages/CommandCenter/KomunitasMouPage';
import { AssetRegistryPage } from './pages/CommandCenter/AssetRegistryPage';
import { AdminPage } from './pages/CommandCenter/AdminPage';
import { KatalogProgramPage } from './pages/CommandCenter/KatalogProgramPage';
import { DistribusiKontenPage } from './pages/CommandCenter/DistribusiKontenPage';
import { ProgressDistribusiPage } from './pages/CommandCenter/ProgressDistribusiPage';
import { ValidasiPostingPage } from './pages/CommandCenter/ValidasiPostingPage';
import { DashboardSosmedPage } from './pages/CommandCenter/DashboardSosmedPage';
import { SkorKinerjaPage } from './pages/CommandCenter/SkorKinerjaPage';
import { ProfilPenerimaPage } from './pages/CommandCenter/ProfilPenerimaPage';
import { ProfilDistributorPage } from './pages/CommandCenter/ProfilDistributorPage';
import { ScoringRulesPage } from './pages/CommandCenter/ScoringRulesPage';
import { AuditLogPage } from './pages/CommandCenter/AuditLogPage';
import { CampaignDetailPage } from './pages/CommandCenter/CampaignDetailPage';
import { PemantauanSosmedPage } from './pages/CommandCenter/PemantauanSosmedPage';
export function App() {
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage data-id="element-4" />} data-id="element-3" />
          <Route path="/unauthorized" element={<UnauthorizedPage data-id="element-6" />} data-id="element-5" />

          {/* Portal Selector */}
          <Route path="/portal" element={<PortalSelector data-id="element-8" />} data-id="element-7" />

          {/* Public Portal Routes */}
          <Route path="/" element={<HomePage data-id="element-10" />} data-id="element-9" />
          <Route path="/bank-konten" element={<BankKontenPage data-id="element-12" />} data-id="element-11" />
          <Route path="/lapor-isu" element={<LaporIsuPage data-id="element-14" />} data-id="element-13" />
          <Route path="/track-laporan" element={<TrackLaporanPage data-id="element-16" />} data-id="element-15" />
          <Route path="/partisipasi" element={<PartisipasiSurveiPage data-id="element-18" />} data-id="element-17" />

          <Route path="/series" element={<SeriesTematikPage data-id="element-20" />} data-id="element-19" />
          <Route path="/series/:id" element={<SeriesDetailPage data-id="element-22" />} data-id="element-21" />

          <Route path="/event" element={<EventAksiPage data-id="element-24" />} data-id="element-23" />
          <Route path="/event/:id" element={<EventDetailPage data-id="element-26" />} data-id="element-25" />
          <Route path="/event/:id/checkin" element={<EventCheckinPage data-id="element-28" />} data-id="element-27" />

          <Route path="/komunitas" element={<KomunitasPage data-id="element-30" />} data-id="element-29" />
          <Route path="/komunitas/:id" element={<KomunitasDetailPage data-id="element-32" />} data-id="element-31" />

          {/* Officer App Routes - Protected for 'officer' role */}
          <Route path="/officer" element={<ProtectedRoute requiredRole={['officer']} data-id="element-34">
                <OfficerDashboard data-id="element-35" />
              </ProtectedRoute>} data-id="element-33" />
          <Route path="/officer/checklist" element={<ProtectedRoute requiredRole={['officer']} data-id="element-37">
                <ChecklistPage data-id="element-38" />
              </ProtectedRoute>} data-id="element-36" />
          <Route path="/officer/laporan" element={<ProtectedRoute requiredRole={['officer']} data-id="element-40">
                <LaporanPage data-id="element-41" />
              </ProtectedRoute>} data-id="element-39" />
          <Route path="/officer/isu" element={<ProtectedRoute requiredRole={['officer']} data-id="element-43">
                <IsuLapanganPage data-id="element-44" />
              </ProtectedRoute>} data-id="element-42" />
          <Route path="/officer/materi" element={<ProtectedRoute requiredRole={['officer']} data-id="element-46">
                <MateriPage data-id="element-47" />
              </ProtectedRoute>} data-id="element-45" />
          <Route path="/officer/proof" element={<ProtectedRoute requiredRole={['officer']} data-id="element-49">
                <ProofOfPerformancePage data-id="element-50" />
              </ProtectedRoute>} data-id="element-48" />
          <Route path="/officer/event" element={<ProtectedRoute requiredRole={['officer']} data-id="element-52">
                <EventOfficerPage data-id="element-53" />
              </ProtectedRoute>} data-id="element-51" />
          <Route path="/officer/distribusi" element={<ProtectedRoute requiredRole={['officer']} data-id="element-55">
                <DistribusiDariPusatPage data-id="element-56" />
              </ProtectedRoute>} data-id="element-54" />
          <Route path="/officer/distribusi/:id" element={<ProtectedRoute requiredRole={['officer']} data-id="element-58">
                <DetailAssignmentPage data-id="element-59" />
              </ProtectedRoute>} data-id="element-57" />
          <Route path="/officer/submit-bukti/:id" element={<ProtectedRoute requiredRole={['officer']} data-id="element-61">
                <SubmitBuktiPostingPage data-id="element-62" />
              </ProtectedRoute>} data-id="element-60" />

          {/* Command Center Routes - Protected for admin roles */}
          <Route path="/command-center" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-64">
                <DashboardNasional data-id="element-65" />
              </ProtectedRoute>} data-id="element-63" />
          <Route path="/command-center/skoring" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-67">
                <SkoringDaerahPage data-id="element-68" />
              </ProtectedRoute>} data-id="element-66" />
          <Route path="/command-center/isu" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-70">
                <IsuKrisisPage data-id="element-71" />
              </ProtectedRoute>} data-id="element-69" />
          <Route path="/command-center/konten" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-73">
                <ManajemenKontenPage data-id="element-74" />
              </ProtectedRoute>} data-id="element-72" />
          <Route path="/command-center/event" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-76">
                <EventNasionalPage data-id="element-77" />
              </ProtectedRoute>} data-id="element-75" />
          <Route path="/command-center/komunitas" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-79">
                <KomunitasMouPage data-id="element-80" />
              </ProtectedRoute>} data-id="element-78" />
          <Route path="/command-center/assets" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-82">
                <AssetRegistryPage data-id="element-83" />
              </ProtectedRoute>} data-id="element-81" />
          <Route path="/command-center/admin" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-85">
                <AdminPage data-id="element-86" />
              </ProtectedRoute>} data-id="element-84" />
          <Route path="/command-center/katalog" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-88">
                <KatalogProgramPage data-id="element-89" />
              </ProtectedRoute>} data-id="element-87" />

          {/* Distribution System Routes */}
          <Route path="/command-center/distribusi" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-91">
                <DistribusiKontenPage data-id="element-92" />
              </ProtectedRoute>} data-id="element-90" />
          <Route path="/command-center/distribusi/campaign/:id" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-94">
                <CampaignDetailPage data-id="element-95" />
              </ProtectedRoute>} data-id="element-93" />
          <Route path="/command-center/distribusi/progress" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-97">
                <ProgressDistribusiPage data-id="element-98" />
              </ProtectedRoute>} data-id="element-96" />
          <Route path="/command-center/distribusi/validasi" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-100">
                <ValidasiPostingPage data-id="element-101" />
              </ProtectedRoute>} data-id="element-99" />
          <Route path="/command-center/sosmed" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-103">
                <DashboardSosmedPage data-id="element-104" />
              </ProtectedRoute>} data-id="element-102" />
          <Route path="/command-center/pemantauan-sosmed" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-106">
                <PemantauanSosmedPage data-id="element-107" />
              </ProtectedRoute>} data-id="element-105" />
          <Route path="/command-center/skor-kinerja" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-109">
                <SkorKinerjaPage data-id="element-110" />
              </ProtectedRoute>} data-id="element-108" />
          <Route path="/command-center/profil-penerima" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-112">
                <ProfilPenerimaPage data-id="element-113" />
              </ProtectedRoute>} data-id="element-111" />
          <Route path="/command-center/profil-distributor" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-115">
                <ProfilDistributorPage data-id="element-116" />
              </ProtectedRoute>} data-id="element-114" />
          <Route path="/command-center/admin/scoring-rules" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-118">
                <ScoringRulesPage data-id="element-119" />
              </ProtectedRoute>} data-id="element-117" />
          <Route path="/command-center/admin/audit-logs" element={<ProtectedRoute requiredRole={['super_admin', 'regional_admin', 'viewer']} data-id="element-121">
                <AuditLogPage data-id="element-122" />
              </ProtectedRoute>} data-id="element-120" />

          {/* Fallback for other routes */}
          <Route path="*" element={<HomePage data-id="element-124" />} data-id="element-123" />
        </Routes>
      </Router>
    </AuthProvider>;
}